namespace TabAurous.Inventory {
    export interface LotCreationDetailsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        NewProductId?: number;
        NewProductCode?: string;
        HasBom?: boolean;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        Hsn?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        AllotedPieces?: number;
        AllotedWeight?: number;
        AllotedNetWeight?: number;
        BalancePieces?: number;
        BalanceWeight?: number;
        BalanceNetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        CostMethodId?: number;
        RefTransItemId?: number;
        RefTransTypeId?: number;
        RefTransId?: number;
        StockId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        DiscountPer?: number;
        Lab?: string;
        NewPieces?: number;
        NewGrossWeight?: number;
        NewNetWeight?: number;
        NewStoneWeight?: number;
        GenerateLot?: string;
        ItemsDetails?: LotCreationItemsRow[];
        Purity?: number;
        PureWeight?: number;
        LedgerName?: string;
    }

    export namespace LotCreationDetailsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.LotCreationDetails';
        export const deletePermission = 'Inventory:LotCreation:Delete';
        export const insertPermission = 'Inventory:LotCreation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:LotCreation:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            NewProductId = "NewProductId",
            NewProductCode = "NewProductCode",
            HasBom = "HasBom",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            Hsn = "Hsn",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            AllotedPieces = "AllotedPieces",
            AllotedWeight = "AllotedWeight",
            AllotedNetWeight = "AllotedNetWeight",
            BalancePieces = "BalancePieces",
            BalanceWeight = "BalanceWeight",
            BalanceNetWeight = "BalanceNetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            CostMethodId = "CostMethodId",
            RefTransItemId = "RefTransItemId",
            RefTransTypeId = "RefTransTypeId",
            RefTransId = "RefTransId",
            StockId = "StockId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            DiscountPer = "DiscountPer",
            Lab = "Lab",
            NewPieces = "NewPieces",
            NewGrossWeight = "NewGrossWeight",
            NewNetWeight = "NewNetWeight",
            NewStoneWeight = "NewStoneWeight",
            GenerateLot = "GenerateLot",
            ItemsDetails = "ItemsDetails",
            Purity = "Purity",
            PureWeight = "PureWeight",
            LedgerName = "LedgerName"
        }
    }
}
